/** Recherche de ville (géocodage) via l'API Open-Meteo. */
export const searchCity = async (query) => {
  const url = `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(query)}&count=8&language=fr&country=FR`;
  const res = await fetch(url);
  const data = await res.json();
  return data.results || [];
};

/** Moyenne mensuelle des précipitations 2015-2024 pour une position donnée. */
export const fetchClimateMonthlyRainfall = async (lat, lon) => {
  const start = '2015-01-01', end = '2024-12-31';
  const url = `https://archive-api.open-meteo.com/v1/archive?latitude=${lat}&longitude=${lon}&start_date=${start}&end_date=${end}&daily=precipitation_sum&timezone=UTC`;
  const res = await fetch(url);
  const data = await res.json();
  if (!data.daily || !data.daily.time) {
    throw new Error('Données indisponibles pour cette ville.');
  }
  const monthSums = Array(12).fill(0);
  data.daily.time.forEach((d, i) => {
    const m = parseInt(d.slice(5, 7), 10) - 1;
    const v = data.daily.precipitation_sum[i];
    if (v !== null) monthSums[m] += v;
  });
  return monthSums.map(s => Math.round((s / 10) * 10) / 10); // moyenne sur 10 ans
};
